<template>

  <v-card class="ma-3" outlined>

    <v-card-title>
      <v-row no-gutters align="center">
        {{room.name}}
        <sub class="ml-1 grey--text">(ID: {{room.id}})</sub>
        <v-spacer/>
        <div class="ma-n1">
          <v-btn depressed color="primary" class="ma-1" @click="$emit('inventory', room)">Inventar</v-btn>
          <v-btn depressed color="primary" class="ma-1" @click="$emit('pricing', room)">Preturi</v-btn>
        </div>
      </v-row>
    </v-card-title>


    <v-divider class="mx-4"/>

    <v-card-text class="sheet-wrapper" ref="sheet-wrapper" @scroll="$emit('scroll', room)" @mouseover="$emit('select', room)">

      <table class="sheet sheet-highlight">

        <colgroup>
          <col/>
          <col v-for="(day, index) in days" :key="'day' + index" :class="column_class(day)"/>
        </colgroup>


        <thead>
        <tr class="white">
          <th></th>
          <th v-for="(day, index) in days" :key="'month' + index" class="sheet-date text-capitalize pa-1" :style="{ backgroundColor: !month(day) ? 'transparent' : 'white'}">
            {{ month(day) }}
          </th>
        </tr>
        <tr>
          <th class="sheet-header text-center" style="border-top: 1px solid white; border-left: 1px solid white;"></th>
          <th v-for="(day, index) in days" :key="index" class="sheet-cell" style="border-top: 2px solid rgba(0, 0, 0, .1);">
            {{ $moment(day).format('ddd') }} {{ $moment(day).format('D') }}
          </th>
        </tr>
        </thead>


        <tbody>

        <im-co-row :inventories="sheet.inventory[room.id]"/>
        <im-av-row :inventories="sheet.inventory[room.id]"/>
        <im-re-row :inventories="sheet.inventory[room.id]"/>
        <im-bo-row :inventories="sheet.inventory[room.id]"/>

        <template v-for="rate in room.rate_plans">

          <template v-if="
            (types.includes('cost') && rate.type === 'cost') ||
            (types.includes('sale') && rate.type === 'sale') ||
            (types.includes('offer') && rate.type === 'offer')
          ">

            <im-ra-row :rate="rate" :prices="sheet.pricing[room.id][rate.id]"/>
            <im-ss-row v-if="rate.show" :prices="sheet.pricing[room.id][rate.id]"/>
            <im-ad-row v-if="rate.show" :prices="sheet.pricing[room.id][rate.id]"/>
            <im-in-row v-if="rate.show" :prices="sheet.pricing[room.id][rate.id]"/>
            <im-st-row v-if="rate.show" :prices="sheet.pricing[room.id][rate.id]"/>
            <im-ms-row v-if="rate.show" :prices="sheet.pricing[room.id][rate.id]"/>
            <im-da-row v-if="rate.show" :prices="sheet.pricing[room.id][rate.id]"/>

          </template>

        </template>

        </tbody>

      </table>

    </v-card-text>

  </v-card>


</template>


<script>
  export default {

    components: {
      'im-co-row': () => import('./Rows/SheetRowClosedOut'),
      'im-av-row': () => import('./Rows/SheetRowAvailability'),
      'im-bo-row': () => import('./Rows/SheetRowBooked'),
      'im-re-row': () => import('./Rows/SheetRowRelease'),
      'im-ra-row': () => import('./Rows/SheetRowRate'),
      'im-ss-row': () => import('./Rows/SheetRowStopSell'),
      'im-ad-row': () => import('./Rows/SheetRowArrivalDeparture'),
      'im-in-row': () => import('./Rows/SheetRowInventory'),
      'im-st-row': () => import('./Rows/SheetRowStayThrough'),
      'im-ms-row': () => import('./Rows/SheetRowStay'),
      'im-da-row': () => import('./Rows/SheetRowDaysAdvance')
    },

    props: {
      days: null,
      room: null,
      rates: [],
      sheet: null,
      period: null,
      types: Array
    },

    methods: {

      column_class: function (day) {
        return {
          weekday: true,
          weekend: this.$moment(day).locale('en').format('dddd') === 'Saturday' || this.$moment(day).locale('en').format('dddd') === 'Sunday',
        }
      },

      month: function (day) {
        let month_start = this.$moment(day).startOf('day');
        if (month_start.format('YYYY-MM-DD') === this.days[0]) return month_start.format('MMM YYYY');
        if (month_start.format('YYYY-MM-DD') === month_start.clone().startOf('month').format('YYYY-MM-DD')) return month_start.format('MMM YYYY');
        return null;
      }

    }
  }

</script>


<style scoped>
  @import 'sheet.css';
</style>